import React from 'react';
import Icon from '../../../components/AppIcon';

const StatisticsPanel = ({ currentData, currentRealTimeData, historicalStats }) => {
  const stats = [
    {
      label: 'Current Ratio',
      value: `${(currentRealTimeData?.ratio || currentData?.ratio || 0)?.toFixed(4)}%`,
      icon: 'PieChart',
      color: 'text-primary'
    },
    {
      label: 'Period Change',
      value: `${currentData?.change >= 0 ? '+' : ''}${(currentData?.change || 0)?.toFixed(2)}%`,
      icon: currentData?.change >= 0 ? 'TrendingUp' : 'TrendingDown',
      color: currentData?.change >= 0 ? 'text-success' : 'text-error'
    },
    {
      label: 'Period High',
      value: `${(historicalStats?.high || 0)?.toFixed(4)}%`,
      icon: 'ArrowUp',
      color: 'text-success'
    },
    {
      label: 'Period Low',
      value: `${(historicalStats?.low || 0)?.toFixed(4)}%`,
      icon: 'ArrowDown',
      color: 'text-error'
    },
    {
      label: 'Average',
      value: `${(historicalStats?.average || 0)?.toFixed(4)}%`,
      icon: 'Activity',
      color: 'text-secondary'
    },
    {
      label: 'Volatility',
      value: `${(historicalStats?.volatility || 0)?.toFixed(2)}%`,
      icon: 'BarChart3',
      color: 'text-warning'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-3 md:p-4 transition-all duration-300 hover:shadow-md hover:border-primary/50"
        >
          <div className="flex items-center gap-2 mb-2">
            <div className={`flex items-center justify-center w-8 h-8 md:w-10 md:h-10 rounded-full bg-muted ${stat?.color}`}>
              <Icon name={stat?.icon} size={16} color="currentColor" />
            </div>
          </div>
          <p className="text-xs md:text-sm text-muted-foreground mb-1">{stat?.label}</p>
          <p className={`text-lg md:text-xl lg:text-2xl font-semibold ${stat?.color}`}>
            {stat?.value}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StatisticsPanel;